import React from "react"
import { Link } from "react-router-dom"
import { ArrowRight, ArrowUpRight } from "lucide-react"
import SectionHeading from "./SectionHeading.jsx"
import { FEATURED_PROJECTS } from "../../data/featuredProjects.js"

function Detail({ label, value }) {
  if (!value) return null

  return (
    <div>
      <dt className="text-xs font-semibold uppercase tracking-wide text-brand-textSoft">{label}</dt>
      <dd className="mt-1 text-brand-text">{value}</dd>
    </div>
  )
}

export default function SelectedProjects() {
  return (
    <section id="work" aria-labelledby="work-heading" className="scroll-mt-24 bg-brand-bg py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading
            id="work-heading"
            eyebrow="Selected work"
            title="Recent client work"
            lead="A selection of live client websites we have worked on, from health and creative businesses to community organisations and online retail."
          />
          <Link
            to="/portfolio"
            className="inline-flex shrink-0 items-center gap-2 font-semibold text-brand-primary hover:underline"
          >
            View all work
            <ArrowRight aria-hidden="true" className="h-4 w-4" />
          </Link>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {FEATURED_PROJECTS.map((project) => {
            const hasDetails = project.challenge || project.delivered || project.outcome

            return (
              <li
                key={project.client}
                className="overflow-hidden rounded-xl2 border border-brand-border bg-white shadow-card"
              >
                <img
                  src={project.image}
                  alt={`Homepage of the ${project.client} website`}
                  width={900}
                  height={600}
                  loading="lazy"
                  decoding="async"
                  className="aspect-[3/2] w-full border-b border-brand-border object-cover object-top"
                />
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-brand-heading">{project.client}</h3>

                  {hasDetails && (
                    <dl className="mt-4 space-y-3 text-sm">
                      <Detail label="Challenge" value={project.challenge} />
                      <Detail label="Work delivered" value={project.delivered} />
                      <Detail label="Outcome" value={project.outcome} />
                    </dl>
                  )}

                  <a
                    href={project.liveLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-primary hover:underline"
                  >
                    Visit live site
                    <ArrowUpRight aria-hidden="true" className="h-4 w-4" />
                    <span className="sr-only">(opens in a new tab)</span>
                  </a>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
